// PTP step type labels, keyed by the backend PTPItemType int value.
// 0 = PurchaseRequest, 1 = PurchaseOrder, 2 = Report, 3 = Dashboard (ports the legacy PTPItemType enum).
export const PTPStepTypeLabels: {[key: number]: string} = {
    0: "Purchase Request",
    1: "Purchase Order",
    2: "Report",
    3: "Dashboard"
};

export const PTPStepTypeOptions = [
    {value: 0, label: "Purchase Request"},
    {value: 1, label: "Purchase Order"},
    {value: 2, label: "Report"},
    {value: 3, label: "Dashboard"}
];
